import { IAccordionData } from "@/models/IAccordionData";
import s2Icon1 from "../../assets/icons/capabilities-toxicology-s2-1.png";
import s2Icon2 from "../../assets/icons/capabilities-toxicology-s2-2.png";
import s2Icon3 from "../../assets/icons/capabilities-toxicology-s2-3.png";
import CapabilitiesTextContainer from "../../components/capabilitiesTextContainer";
import AccordionWrapper from "../../components/accordionWrapper";
import Arrow from "../../components/Arrow";

const accordionDataRaw: {
  header: string;
  description: string;
  data: {
    header: string;
    headerSection?: string;
    header2?: string;
    icon: JSX.Element;
    data: string | string[];
  }[];
  description2?: string;
  data2?: {
    header: string;

    data: string | string[];
  };
}[] = [
  {
    header: "Immunogenicity",
    description: "Lilly ExploR&D Capability Across Modalities",
    data: [
      {
        headerSection: "",
        icon: <></>,
        header: "Antibodies",
        data: [
          "In silico predictive immunogenicity",
          "Antigen presenting cell internalization assay",
          "Serum protein and/or pre-existing Immunoglobulin G (IgG)",
          "Medicines Adaptive Pathway to Patients (MAPPs) assay to identify Human Leukocyte Antigen Class-II (HLA-II) displayed peptides",
          "Intact molecule and/or Medicines Adaptive Pathway to Patients (MAPPs) observed peptides",
        ],
      },
      {
        headerSection: "",
        icon: <></>,
        header: "Peptides",
        data: [
          "Serum protein and/or pre-existing Immunoglobulin G (IgG)",
          "Medicines Adaptive Pathway to Patients (MAPPs) assay to identify Human Leukocyte Antigen Class-II (HLA-II) displayed peptides",
          "Intact molecule and/or Medicines Adaptive Pathway to Patients (MAPPs) observed peptides",
        ],
      },
    ],
  },
  {
    header: "Toxicology & Pathology",
    description: "",
    data: [
      {
        header: "Profiling Characterization",
        header2: "Lead Molecules",
        headerSection: "Discovery Molecule(s)",
        icon: (
          <img
            src={s2Icon1}
            alt="Profiling Characterization"
            className="h-12"
          />
        ),
        data: [
          "Early target safety assessment",
          "In silico investigations",
          "In vitro profiling",
        ],
      },
      {
        icon: <img src={s2Icon2} alt="Lead Optimization" className="h-12" />,
        header: "Lead Optimization",
        header2: "Development Candidate",
        data: [
          "In vitro assessment of gene-tox and cardiovascular (CV) risk",
          "Toxicology screening studies and pilot studies",
          "Access to investigative toxicology expertise",
        ],
      },
      {
        headerSection: "First Human Dose",
        icon: (
          <img src={s2Icon3} alt="FIH Enabling Toxicology" className="h-12" />
        ),
        header: "First-in-Human (FIH) Enabling Toxicology",
        header2: "IND/CTA Submission",
        data: [
          "Good Laboratory Practices (GLP) toxicology studies",
          "Pathology peer review",
          "Investigational New Drug/Clinical Trial Application (IND/CTA) preparation",
        ],
      },
    ],
    description2:
      "Post First-in-Human (FIH) Nonclinical Safety Strategy for Clinical Progression",
    data2: {
      header: "",
      data: [
        "Chronic toxicology",
        "Qualification studies",
        "Combination toxicology",
        "Carcinogenicity",
        "Developmental and reproductive toxicology (DART)",
        "Weight-of-evidence waivers",
        "Drug abuse liability (DAL)",
        "Regulatory interaction/responses",
      ],
    },
  },
];

const Toxicology = (props: {
  accordionOpenHeader: string;
  setAccordionOpenHeader: React.Dispatch<React.SetStateAction<string>>;
}) => {
  const accordionData: IAccordionData[] = [
    //Immunogenicity
    {
      header: accordionDataRaw[0].header,
      body: (
        <div className="px-4 py-4">
          <div className="text-xl font-light">
            {accordionDataRaw[0].description}
          </div>
          <div className="my-8 grid xl:grid-cols-2 grid-cols-1 gap-4 xl:gap-2 items-center h-full">
            {accordionDataRaw[0].data.map((el, index) => (
              <div className="h-full">
                <CapabilitiesTextContainer>
                  <div className="font-medium mb-2">{el.header}</div>
                  <ul className="px-4">
                    {Array.isArray(el.data) &&
                      el.data.map((point) => <li className="py-1">{point}</li>)}
                  </ul>
                </CapabilitiesTextContainer>
              </div>
            ))}
          </div>
        </div>
      ),
    },
    {
      header: accordionDataRaw[1].header,
      body: (
        <>
          <div className="p-4">
            <div className="my-8 xl:grid-cols-3 grid-cols-1 gap-2 hidden xl:grid">
              {accordionDataRaw[1].data.map((el, index) => (
                <>
                  <div className="flex flex-col justify-end">
                    <div className="flex flex-col justify-center align-baseline w-full relative">
                      {el.headerSection && (
                        <div
                          className={`mb-8 text-lg font-semibold flex w-full ${index === 2 ? "justify-end" : ""}`}
                        >
                          <div
                            className="w-fit"
                            id={`headerSection-s2-${index + 1}`}
                          >
                            {el.headerSection}
                          </div>
                        </div>
                      )}
                      <div className="w-full flex justify-between items-center">
                        <div className="w-fit" id={`icon-s2-${index + 1}`}>
                          {el.icon}
                          {index === 2 && (
                            <div
                              className="h-0 w-0 bg-red-500 absolute right-0 bottom-6"
                              id={`marker-s2-3`}
                            ></div>
                          )}
                        </div>
                        <div
                          className="text-lg font-semibold"
                          id={`headerSection-middle-s2-${index + 1}`}
                        >
                          {el.header2}
                        </div>
                        <div></div>
                      </div>
                    </div>
                  </div>
                </>
              ))}
              {accordionDataRaw[1].data.map((el, index) => (
                <>
                  <div className="flex flex-col">
                    <CapabilitiesTextContainer>
                      <div className="font-medium mb-2">{el.header}</div>
                      <div className="font-normal my-2">Support for:</div>
                      <ul className="px-8">
                        {Array.isArray(el.data) &&
                          el.data.map((point) => (
                            <li className="py-1">{point}</li>
                          ))}
                      </ul>
                    </CapabilitiesTextContainer>
                  </div>
                </>
              ))}
            </div>
            {props.accordionOpenHeader === accordionDataRaw[1].header && (
              <div className="hidden xl:block">
                <Arrow
                  fromId="headerSection-s2-1"
                  toId="icon-s2-1"
                  dashed
                  type="mobile"
                />
                <Arrow fromId="icon-s2-1" toId="headerSection-middle-s2-1" />
                <Arrow fromId="headerSection-middle-s2-1" toId="icon-s2-2" />
                <Arrow fromId="icon-s2-2" toId="headerSection-middle-s2-2" />
                <Arrow fromId="headerSection-middle-s2-2" toId="icon-s2-3" />
                <Arrow fromId="icon-s2-3" toId="headerSection-middle-s2-3" />
                <Arrow
                  fromId="headerSection-middle-s2-3"
                  toId="marker-s2-3"
                  dashed
                />
                <Arrow
                  toId="marker-s2-3"
                  fromId="headerSection-s2-3"
                  dashed
                  type="mobile"
                  fromEnd
                />
              </div>
            )}
            <div className="my-8 flex flex-col gap-2 xl:hidden w-full">
              {accordionDataRaw[1].data.map((el, index) => (
                <div>
                  {index !== 2 && (
                    <div
                      className="mb-8 font-semibold"
                      id={`headerSection-s2-${index + 1}-mobile`}
                    >
                      {el.headerSection}
                    </div>
                  )}

                  <div className="flex gap-4 w-full">
                    <div
                      className="w-12 min-w-12 h-fit"
                      id={`icon-s2-${index + 1}-mobile`}
                    >
                      {el.icon}
                    </div>
                    <div className="flex-grow">
                      <CapabilitiesTextContainer>
                        <div className="font-medium mb-2">{el.header}</div>
                        <ul className="px-4">
                          {Array.isArray(el.data) &&
                            el.data.map((point) => (
                              <li className="py-1">{point}</li>
                            ))}
                        </ul>
                      </CapabilitiesTextContainer>
                    </div>
                  </div>

                  <div
                    className="my-4 font-semibold"
                    id={`header2-middle-s2-${index + 1}-mobile`}
                  >
                    {el.header2}
                  </div>
                  {index === 2 && (
                    <div
                      className="mt-8 font-semibold"
                      id={`headerSection-s2-${index + 1}-mobile`}
                    >
                      {el.headerSection}
                    </div>
                  )}
                </div>
              ))}
              {props.accordionOpenHeader === accordionDataRaw[1].header && (
                <div className="xl:hidden block">
                  <Arrow
                    fromId="headerSection-s2-1-mobile"
                    toId="icon-s2-1-mobile"
                    dashed
                    type="mobile"
                  />
                  <Arrow
                    fromId="icon-s2-1-mobile"
                    toId="header2-middle-s2-1-mobile"
                    type="mobile"
                  />
                  <Arrow
                    fromId="header2-middle-s2-1-mobile"
                    toId="icon-s2-2-mobile"
                    type="mobile"
                  />
                  <Arrow
                    fromId="icon-s2-2-mobile"
                    toId="header2-middle-s2-2-mobile"
                    type="mobile"
                  />
                  <Arrow
                    fromId="header2-middle-s2-2-mobile"
                    toId="header2-middle-s2-3-mobile"
                    type="mobile"
                  />
                  <Arrow
                    fromId="header2-middle-s2-3-mobile"
                    toId="headerSection-s2-3-mobile"
                    type="mobile"
                    dashed
                  />
                </div>
              )}
            </div>

            <div className="text-xl font-light lg:max-w-[40rem] capitalize my-4">
              {accordionDataRaw[1].description2}
            </div>
            <div>
              <CapabilitiesTextContainer>
                <div className="font-normal my-2">Support for:</div>
                <ul className="px-8">
                  <div className="grid lg:grid-cols-2">
                    {Array.isArray(accordionDataRaw[1].data2?.data) &&
                      accordionDataRaw[1].data2?.data.map((point) => (
                        <li className="py-1">{point}</li>
                      ))}
                  </div>
                </ul>
              </CapabilitiesTextContainer>
            </div>
          </div>
        </>
      ),
    },
  ];
  return (
    <AccordionWrapper
      data={accordionData}
      setOpen={props.setAccordionOpenHeader}
      accordionOpenHeader={props.accordionOpenHeader}
    />
  );
};

export default Toxicology;
